import type { FiltersActionsType } from './FiltersDuck.actions'
import type { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import SagaDuck from '@duckness/saga'

export const TypedSagaDuck = SagaDuck<InsightsDashboardPoolState, FiltersActionsType, null>
